import moment, { Moment } from 'moment-timezone';
import { DateFormatConstants } from '../constants';
import { isNullOrUndefined } from './util';

export class DateUtil {
  static isDateToday(date: Moment): boolean {
    return date.isSame(new Date(), 'day');
  }

  static isDateWithinNMinutesOfNow(date: Moment, minutes: number): boolean {
    const timeDifferenceInMinutes = date.diff(moment(), 'minutes');
    return timeDifferenceInMinutes < minutes;
  }

  static isDateAfterNMinutesFromNow(date: Moment, minutes: number): boolean {
    const timeDifferenceInMinutes = moment().diff(date, 'minutes');
    return timeDifferenceInMinutes > minutes;
  }

  static hasExpirationDatePassed(month: number, year: number): boolean {
    const currentDate: Date = new Date();
    const currentYear: number = currentDate.getFullYear();
    const currentMonth: number = currentDate.getMonth() + 1;

    if (currentYear === year) {
      return month < currentMonth;
    }

    return year < currentYear;
  }

  static adjustDateFromLocalToUTC(date: Date): Date {
    return moment(moment(date).utc().format('YYYY-MM-DD HH:mm:ss')).toDate();
  }

  static getFormattedDateInUtc(date: Date, dateFormat: string): string {
    return moment(date).utc().format(dateFormat);
  }

  static serializeDate(date: Date): number {
    if (isNullOrUndefined(date)) {
      return null;
    }

    return date.getTime();
  }

  static deserializeDate(timeSinceEpoch: number): Date {
    if (isNullOrUndefined(timeSinceEpoch)) {
      return null;
    }

    return new Date(timeSinceEpoch);
  }

  static serializeLocalDate(localDate: Date): string {
    if (isNullOrUndefined(localDate)) {
      return null;
    }

    return moment(localDate).format(DateFormatConstants.ISO_LOCAL_DATE);
  }

  static serializeLocalTime(localTime: Date): string {
    if (isNullOrUndefined(localTime)) {
      return null;
    }

    return moment(localTime).format(DateFormatConstants.ISO_LOCAL_TIME);
  }

  static deserializeLocalDate(localDate: string, timeZone?: string): Date {
    if (isNullOrUndefined(localDate)) {
      return null;
    }

    if (isNullOrUndefined(timeZone)) {
      return moment(localDate).toDate();
    }

    return moment.tz(localDate, timeZone).toDate();
  }

  static deserializeLocalTime(localDate: string): Date {
    if (isNullOrUndefined(localDate)) {
      return null;
    }

    return moment(localDate, DateFormatConstants.ISO_LOCAL_TIME).toDate();
  }

  static serializeLocalDateTime(localDateTime: Date): string {
    if (isNullOrUndefined(localDateTime)) {
      return null;
    }

    return moment(localDateTime).format(DateFormatConstants.ISO_LOCAL_DATE_TIME);
  }

  static deserializeLocalDateTime(localDateTime: string): Date {
    if (isNullOrUndefined(localDateTime)) {
      return null;
    }

    return moment(localDateTime).toDate();
  }

  static serializeInstant(instant: Date): string {
    if (isNullOrUndefined(instant)) {
      return null;
    }

    return moment(instant).utc().format(DateFormatConstants.ISO_LOCAL_DATE_TIME) + 'Z';
  }

  static deserializeInstant(instant: number, timeZone?: string): Date {
    if (isNullOrUndefined(instant)) {
      return null;
    }

    if (!isNullOrUndefined(timeZone) && timeZone.length > 0) {
      return moment.tz(instant, timeZone).toDate();
    }

    return moment(instant).toDate();
  }
}
